import React from 'react';
import styled from 'styled-components';
import { useToast } from '../context/ToastContext';
import { ToastDisplay } from './ToastDisplay';

const ToastStackContainer = styled.div<{ $hasConfirmation: boolean }>`
  position: fixed;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 0;
  pointer-events: none;
  
  /* Centrerad position för bekräftelse-toasts */
  ${props => props.$hasConfirmation ? `
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 500px;
    width: calc(100vw - 40px);
  ` : `
    top: calc(env(safe-area-inset-top, 0) + 20px);
    right: 20px;
    max-width: 420px;
  `}

  @media (max-width: 768px) {
    ${props => !props.$hasConfirmation && `
      right: 12px;
      left: 12px;
      max-width: none;
    `}
  }
`;

export const ToastContainer: React.FC = () => {
  const { toasts } = useToast();
  
  // Kolla om det finns bekräftelse-toasts
  const hasConfirmation = toasts.some(toast => toast.type === 'confirmation');

  if (toasts.length === 0) {
    return null;
  }

  return (
    <ToastStackContainer $hasConfirmation={hasConfirmation}>
      {toasts.map(toast => (
        <ToastDisplay key={toast.id} toast={toast} />
      ))}
    </ToastStackContainer>
  );
};
